//function for get current time
const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const timenow = `${hours}:${minutes}`;
  return timenow;
};

const getStartTimeFromCurrentTime = (durationHours) => {
  const now = new Date();
  const startTime = new Date(now.getTime() - durationHours * 60 * 60 * 1000);

  const hours = startTime.getHours().toString().padStart(2, "0");
  const minutes = startTime.getMinutes().toString().padStart(2, "0");

  return `${hours}:${minutes}`;
};

const calculateEndTime = (durationHours, startTime) => {
  // Parse start time into hours and minutes
  const [startHours, startMinutes] = startTime.split(":").map(Number);

  // Convert start time to total minutes since midnight
  const totalStartMinutes = startHours * 60 + startMinutes;

  // Convert duration to minutes and round to nearest whole minute
  const durationMinutes = Math.round(durationHours * 60);

  // Calculate total end minutes and normalize to 0-1439 range (24 hours)
  let totalEndMinutes = totalStartMinutes + durationMinutes;
  totalEndMinutes = totalEndMinutes % 1440; // 1440 minutes = 24 hours

  // Handle negative results (if duration was negative)
  if (totalEndMinutes < 0) {
    totalEndMinutes += 1440;
  }

  // Convert back to hours and minutes
  const hours = Math.floor(totalEndMinutes / 60);
  const minutes = totalEndMinutes % 60;

  // Format to two-digit strings
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
    2,
    "0"
  )}`;
};

//function for calculate and get end time
const getEndTime = (duration, startingTime) => {
  const additionalTime = parseInt(duration, 10);

  let timeParts = startingTime.split(":");
  let hours = parseInt(timeParts[0], 10);
  let minutes = parseInt(timeParts[1], 10);
  let timeDate = new Date();

  timeDate.setHours(hours);
  timeDate.setMinutes(minutes);

  // Calculate the result by adding the number to the time
  let resultDate = new Date(timeDate.getTime() + additionalTime * 60 * 1000);

  // Extract the individual components (hours, minutes) from the result date
  let resultHours = resultDate.getHours();
  let resultMinutes = resultDate.getMinutes();

  // Format the result as a string
  let newHour = resultHours.toString().padStart(2, "0");
  let newMinute = resultMinutes.toString().padStart(2, "0");

  const timeExtended = `${newHour}:${newMinute}`;

  return timeExtended;
};

const getStartTime = (duration, timeStr) => {
  const [hours, minutes] = timeStr.split(":").map(Number);
  const totalMinutes = hours * 60 + minutes;
  const durationInMinutes = duration * 60;

  let startTimeInMinutes = totalMinutes - durationInMinutes;
  if (startTimeInMinutes < 0) {
    startTimeInMinutes += 1440; // Add 24 hours in minutes
  }

  const startHours = Math.floor(startTimeInMinutes / 60) % 24;
  const startMinutes = startTimeInMinutes % 60;

  const formattedHours = String(startHours).padStart(2, "0");
  const formattedMinutes = String(startMinutes).padStart(2, "0");

  return `${formattedHours}:${formattedMinutes}`;
};

//function for get time difference
const getTimeDifference = (timeString) => {
  const [givenHours, givenMinutes] = timeString.split(":").map(Number);

  const now = new Date();
  const currentHours = now.getHours();
  const currentMinutes = now.getMinutes();
  const currentSeconds = now.getSeconds();

  let differenceHours = currentHours - givenHours;
  let differenceMinutes = currentMinutes - givenMinutes;

  if (differenceMinutes < 0) {
    differenceHours -= 1;
    differenceMinutes += 60;
  }

  const differenceSeconds = currentSeconds;

  const formattedDifference = `${
    differenceHours < 10 ? "0" + differenceHours : differenceHours
  }.${differenceMinutes < 10 ? "0" + differenceMinutes : differenceMinutes}.${
    differenceSeconds < 10 ? "0" + differenceSeconds : differenceSeconds
  }`;

  return formattedDifference;
};

//convert time duration into seconds
const differenceToSeconds = (timeString) => {
  const [hours, minutes, seconds] = timeString.split(".").map(Number);
  const totalSeconds = hours * 3600 + minutes * 60 + seconds;
  return totalSeconds;
};

//get converted gantt time
const getConvertedGanttDate = (dateObject) => {
  // Extract date components
  const year = dateObject.getFullYear();
  const month = String(dateObject.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  const day = String(dateObject.getDate()).padStart(2, "0");

  // Formatted date string in yyyy-mm-dd format
  const formattedDate = `${year}-${month}-${day}`;

  // Output the formatted date
  return formattedDate; // Output: 2024-04-13
};

//get converted format for alert
const getAlertDateFormat = (dateString) => {
  if (!dateString || dateString === "") {
    return "";
  }
  // Parse the input date string
  const date = new Date(dateString);

  // Array of month names
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get day, month, and year
  const day = date.getDate();
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();

  // Function to get ordinal suffix for day
  function getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return "th"; // Special case for 11th, 12th, 13th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }

  // Construct formatted date string
  return `${day}${getOrdinalSuffix(day)} ${month} ${year}`;
};

// format current time for view purpose
const displayFormatedTime = (timeInSeconds) => {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds % 3600) / 60);
  const seconds = timeInSeconds % 60;

  return `${hours < 10 ? "0" + hours : hours}:${
    minutes < 10 ? "0" + minutes : minutes
  }:${seconds < 10 ? "0" + seconds : seconds}`;
};

const convertSecondsToHour = (seconds = 0) => {
  if (seconds < 60) return 0;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  // Hour.Minute format
  const formatted = parseFloat(
    `${hours}.${minutes.toString().padStart(2, "0")}`
  );
  return formatted;
};

export {
  getCurrentTime,
  getStartTimeFromCurrentTime,
  calculateEndTime,
  getEndTime,
  getStartTime,
  getTimeDifference,
  differenceToSeconds,
  getConvertedGanttDate,
  getAlertDateFormat,
  displayFormatedTime,
  convertSecondsToHour,
};
